import React from "react";
import Modal from "react-modal";
import { icons } from "@img/icons";

export function ShippingModal({
  isOpen,
  image,
  imageName,
  details,
  onFileUpload,
  onSave,
  onClose,
}) {
  return (
    <Modal
      isOpen={isOpen}
      contentLabel="Export Report"
      className="input-modal"
    >
      <div className="card">
        <div className="card-header">Upload Shipping Label</div>
        <div className="card-body">
          <div className="border">
            <img src={image} alt="" />
            <embed
              type="application/pdf"
              src={image || details?.return_label}
              width="600"
              height="400"
            />
            <div>
              <label htmlFor="uploadFile" className="custom-file-upload m-3">
                {"Upload "} <img src={icons.Upload} alt="" />
              </label>
              <small>{`${imageName ? imageName : "No file choosen"}`}</small>
              <input
                accept="application/pdf"
                type="file"
                id="uploadFile"
                onChange={onFileUpload}
              />
            </div>
          </div>
        </div>
        <div className="card-footer">
          <button
            type="submit"
            className={`btn btn-outline-primary mr-3 ${!imageName && " disabled"}`}
            data-testid="modal-upload-btn"
            onClick={onSave}
          >
            Save
          </button>
          <button
            type="button"
            className="btn btn-outline-secondary"
            data-testid="modal-decline-btn-cancel"
            onClick={onClose}
          >
            Cancel
          </button>
        </div>
      </div>
    </Modal>
  );
}
